import { render, staticRenderFns } from "./ProfileListAddv2.vue?vue&type=template&id=454e5a18&scoped=true&"
import script from "./ProfileListAddv2.vue?vue&type=script&lang=js&"
export * from "./ProfileListAddv2.vue?vue&type=script&lang=js&"
import style0 from "./ProfileListAddv2.vue?vue&type=style&index=0&id=454e5a18&lang=scss&scoped=true&"
import style1 from "./ProfileListAddv2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e5a18",
  null
  
)

export default component.exports